// https://biati-digital.github.io/glightbox
// https://github.com/biati-digital/glightbox/blob/master/README.md
import GLightbox from '../../../../../assets/vendor/glightbox/glightbox.min.js';

export default class GalleryLightboxes {
    constructor($element) {
        this.$element = $element;

        const gallery = new GLightbox({
            selector : this.$element.dataset.galleryLightboxes,
        });
    }
}